<template>
  <div>
    <!-- Waiting for plan to load — render nothing to avoid flash -->
    <template v-if="!planLoaded"></template>
    <slot v-else-if="hasAccess" />
    <div v-else class="plan-gate">
      <div class="plan-gate__icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="40"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#2d2b55"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
          <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
        </svg>
      </div>
      <h3 class="plan-gate__title">{{ title }}</h3>
      <p class="plan-gate__description">{{ description }}</p>
      <router-link :to="{ name: 'plans' }" class="plan-gate__btn">
        Ver planes
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "PlanGate",
  props: {
    feature: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: "Función no disponible en tu plan"
    },
    description: {
      type: String,
      default: "Mejora tu plan para acceder a esta funcionalidad."
    }
  },
  computed: {
    planLoaded() {
      return this.$store.getters.userPlanLoaded;
    },
    hasAccess() {
      return this.$store.getters.hasFeature(this.feature);
    }
  }
};
</script>

<style scoped>
.plan-gate {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  text-align: center;
  min-height: 320px;
}

.plan-gate__icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #f7f8fc;
  border: 2px solid #e8e7e3;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
}

.plan-gate__title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #2d2b55;
  margin-bottom: 0.5rem;
}

.plan-gate__description {
  color: #6b7280;
  font-size: 0.95rem;
  margin-bottom: 1.5rem;
  max-width: 360px;
}

.plan-gate__btn {
  display: inline-block;
  padding: 0.6rem 1.5rem;
  background: #2d2b55;
  color: #fff;
  border-radius: 10px;
  font-weight: 600;
  font-size: 0.9rem;
  text-decoration: none;
  transition: background 0.2s;
}

.plan-gate__btn:hover {
  background: #3ecfb4;
  color: #fff;
  text-decoration: none;
}
</style>
